import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common'
import { MdlSelectModule } from '@angular-mdl/select';
import { MdlModule } from '@angular-mdl/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '../../../translate/translate.module';
import { PipeModule } from '../../../pipes/pipes.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { CopyrightFooterModule } from '../copyright-footer/copyright-footer.module';

import { HeaderNavComponent } from './header-nav.component';
import { ActionRequiredListComponent } from '../action-required/action-required.component';

import { MbscModule, mobiscroll } from "@mobiscroll/angular";
import { InfiniteScrollModule } from 'angular2-infinite-scroll';

let currentYear = new Date().getFullYear();

mobiscroll.settings = {
    theme: 'ios',
    themeVariant: 'light',
    display: 'bubble',
    dateFormat: "mm/dd/yy",
    returnFormat: 'locale',
    focusOnClose: false,
    defaultValue: new Date("01/01/" + currentYear)
};

@NgModule({
	imports: [
		CommonModule,
		HttpModule,
		PipeModule,
		TranslateModule,
		DirectivesModule,
		CopyrightFooterModule,
		MdlSelectModule,
		MdlModule,
		FormsModule,
		MatTooltipModule,
		MbscModule,
		InfiniteScrollModule
	],
	declarations: [
		HeaderNavComponent,
		ActionRequiredListComponent
	],
	exports: [HeaderNavComponent]
})
export class HeaderNavModule { }
